import { createStore } from '@/store/createStore';

export { createStore };
export default createStore();
